import React from 'react'
import { Row, Typography, Card } from 'antd'
import { EmptyHeaderHero, EmailGlobalHeader, GlobalFooter } from './components'
import { useRouter } from 'next/router'
import { twilioRegistration } from '../services/Api'
import { useEffect, useRef } from 'react'

const { Link } = Typography

const SignUpResults = () => {
  const router = useRouter();
  const hasOptedIn = useRef(false)

  useEffect(() => {
    if (hasOptedIn.current === false & !!router.query.policyNumber && !!router.query.phoneNumber && !!router.query.state) {
      var twilioUser = {
        ApplicationNumber: null,
        PolicyNumber: router.query.policyNumber,
        PhoneNumber: router.query.phoneNumber,
        State: router.query.state,
        Env: "prod",
        OptInChannel: "MyAccount"
      }
      twilioRegistration({ OptIn: twilioUser })
      hasOptedIn.current = true
    }
  },[router.query])

  return (
    <div className='container'>
      <EmailGlobalHeader />
      <>
        <EmptyHeaderHero
          minHeight={true}
          title='Thank you for signing up for texts!'
        />
        <div className="express-policy-results vh-71">
          <Row>
            <Card className="register-card">
              <Link className='link-text'>
                Talk to you soon. Drive well.
              </Link>
            </Card>
          </Row>
        </div>
      </>
      <GlobalFooter />
    </div>
  )
}

SignUpResults.propTypes = {}

export default SignUpResults
